export class AppSettings {
  public static WHATSAPP_API = 'https://api.WhatsApp.com/send?phone=';
  public static ENVIA = 'Envia';
  public static INTERRAPIDISIMO = 'InterRapidisimo';
  public static SERVIENTREGA = 'Servientrega';
  public static ENVIA_IMG = 'assets/images/envia.png';
  public static INTERRAPIDISIMO_IMG = 'assets/images/interrapidisimo.png';
  public static SERVIENTREGA_IMG = 'assets/images/servientrega.png';
  public static LIDER_DEFAULT = 'Lovkc2';
}
